import { XMarkIcon } from '@heroicons/react/24/solid';
import { Button } from "@aidkitorg/component-library"
import { useLocalizedStrings } from '../Localization';

interface TagDisplayProps {
  tags: string[];
  addingNewTag?: boolean;
  onRemove: (tag: string) => void;
  onAddTagClick: () => void;
  className?: string;
}

export function TagDisplay({ tags, addingNewTag, onRemove, onAddTagClick, className = '' }: TagDisplayProps) {
  const L = useLocalizedStrings();

  return (
    <div className={`flex flex-wrap my-2 items-center gap-2 ${className}`}>
      {tags.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center gap-1 px-2 py-1 text-sm bg-indigo-100 text-indigo-800 rounded-full"
        >
          {tag}
          <button
            type="button"
            aria-label={`${L.support.tags.remove_tag} ${tag}`}
            onClick={() => onRemove(tag)}
            className="text-indigo-600 hover:text-indigo-800"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </span>
      ))}
      {!addingNewTag && (
        <Button size="sm" disabled={addingNewTag} onClick={onAddTagClick}>{L.support.tags.add_tag}</Button>
      )}
    </div>
  );
} 